export default __webpack_public_path__ + "static/media/twitter.31779451.png";